import {Injectable} from '@angular/core';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PriceService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public managePrice(price, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/price/' + id, price)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/price/new', price)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
